import { render, staticRenderFns } from "./ListDetailCollapseBunches.vue?vue&type=template&id=16c241fc"
import script from "./ListDetailCollapseBunches.vue?vue&type=script&lang=js"
export * from "./ListDetailCollapseBunches.vue?vue&type=script&lang=js"
import style0 from "./ListDetailCollapseBunches.vue?vue&type=style&index=0&id=16c241fc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c241fc')) {
      api.createRecord('16c241fc', component.options)
    } else {
      api.reload('16c241fc', component.options)
    }
    module.hot.accept("./ListDetailCollapseBunches.vue?vue&type=template&id=16c241fc", function () {
      api.rerender('16c241fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/services/components/ListDetailCollapseBunches.vue"
export default component.exports